import {Component, Injectable} from '@angular/core';
import {HeaderComponent} from '@app/components/header/header.component';
import {SidebarComponent} from '@app/components/sidebar/sidebar.component';
import {RouterOutlet} from '@angular/router';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  imports: [
    RouterOutlet,
    CommonModule,
    HeaderComponent,
    SidebarComponent
  ],
  styleUrls: ['./layout.component.scss']
})

@Injectable()
export class LayoutComponent {
  collapedSideBar = false;

  constructor() {
  }

  receiveCollapsed($event: any) {
    this.collapedSideBar = $event;
  }

  public handleClick() {
    const date = new Date();
    localStorage.setItem('activeTime', date.toString());
  }
}
